<template>
    <div :style>
        <header>
            <LayoutDefaultMobileHeader ref="header" />
        </header>
        <main>
            <slot />
        </main>
        <footer>
            <LayoutDefaultMobileFooter ref="footer" />
        </footer>
    </div>
</template>

<script lang="ts" setup>
const header = useTemplateRef<HTMLDivElement>("header");
const footer = useTemplateRef<HTMLDivElement>("footer");

const { height: headerHeight } = useElementBounding(header);
const { height: footerHeight } = useElementBounding(footer);

const style = computed(() => ({
    "--header-height": `${headerHeight.value ?? 0}px`,
    "--footer-height": `${footerHeight.value ?? 0}px`,
}));
</script>

<style></style>
